import { Network } from "./network";

// Relay-compatible Asset types

type Type = "LAYER_1" | "SECURED" | "NATIVE" | "SYNTH" | "%future added value";

export interface Asset {
  type: Type;
  chain: Network;
  asset: string;
  metadata: {
    decimals: number;
    symbol: string;
  };
  variants?: {
    layer1?: Asset | null;
    secured?: Asset | null;
    native?: { denom: string } | null;
  } | null;
}

export const assetPairFilter =
  (query?: string) =>
  (a: {
    assetBase: { metadata: { symbol: string } };
    assetQuote: { metadata: { symbol: string } };
  }): boolean => {
    if (!query) return true;

    const parts = query.split(/[\s-\/]/);

    if (parts.length === 1)
      return (
        checkMatch(parts[0], a.assetBase.metadata.symbol) ||
        checkMatch(parts[0], a.assetQuote.metadata.symbol)
      );
    return (
      checkMatch(parts[0], a.assetBase.metadata.symbol) &&
      checkMatch(parts[1], a.assetQuote.metadata.symbol)
    );
  };

const checkMatch = (query: string, target: string): boolean => {
  if (!query) return true;
  if (query === "*") return true;
  return target.toLowerCase().includes(query.toLowerCase());
};
